import { useRef } from 'react'
import {
  TileLayer,
  LayersControl,
  LayerGroup,
  GeoJSON,
  Marker,
  Tooltip,
} from 'react-leaflet'
import L from 'leaflet'
import AutoDriveLegend from './AutoDriveLegend';
import AutoDriveVideo from './AutoDriveVideo'
import { useAppContext } from "../libs/contextLib";
import config from "../config";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

// const customIconCar = L.divIcon({
//   //html: '<i className="fa fa-car fa-2x" />',
//   //iconSize: [30, 42],
//   //iconAnchor: [15, 42],
//   className: 'custom-icon',
//   html: "<div style='background-color:#4838cc;'></div><i class='fa fa-car fa-2x'>",
// })

// const customIconCar = L.icon({
//     iconUrl: require("../images/caricon.png"),

//     iconSize:     [42, 42], // size of the icon
//     iconAnchor:   [15, 42]
// });


const createVehicleIcon = (heading) => {
  return L.divIcon({
    className: 'vehicle-icon',
    html: `<div style="transform: rotate(${heading}deg);">
             <img src="${config.DJANGO_URL}/robotaxi/inner/image/?filename=caricon.png" width="42" />
           </div>`,
    iconSize:   [42, 42], // size of the icon
    iconAnchor: [15, 42],
  });
};

const customIconStation = L.divIcon({
  className: 'custom-div-icon',
  html: "<div style='background-color:#4838cc;' class='marker-pin'></div><i class='fas fa-stop-circle awesome'>",
  iconSize: [30, 42],
  iconAnchor: [15, 42]
});

const LayersRaxione = (props) => {
  const markerRef = useRef(null);
  const { routeAppContext } = useAppContext();

  const vworld_url = `http://api.vworld.kr/req/wmts/1.0.0/${config.VWORLD_API_KEY}/Base/{z}/{y}/{x}.png`

  const eventHandlers = {
    dragstart: () => {
      markerRef.current.setOpacity(0.6);
    },
    dragend: () => {
      markerRef.current.setOpacity(1);
    },
  }

  return (
    <>
      <AutoDriveLegend map={props.map} carInfo={props.carInfoLast} />
      <AutoDriveVideo map={props.map} carInfo={props.carInfoLast} isPopVideoInfo={props.isPopVideoInfo} />
      <LayersControl position="topright">
        <LayersControl.BaseLayer checked name="Basic Map">
          {/* add openstreetmap tile url
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          */}
          {/* add google map tile url  */}
          <TileLayer
            attribution="Google Maps"
            url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
          />
        </LayersControl.BaseLayer>
        <LayersControl.BaseLayer name="Esri Satellite Map">
            <TileLayer
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
            />
        </LayersControl.BaseLayer>
        <LayersControl.BaseLayer name="Topo Map">
          <TileLayer
            attribution='Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
            url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
          />
        </LayersControl.BaseLayer>
        <LayersControl.BaseLayer name="VWorld Map">
          <TileLayer
            attribution='&copy; <a href="https://www.vworld.kr/">VWorld Map</a> contributors'
            url={vworld_url}
          />
        </LayersControl.BaseLayer>
        <LayersControl.Overlay checked name="TechnoPolice">
          <GeoJSON key={props.geoJsonKey} style={{color: "red", weight: 2}} data={props.geoJsonData} />
        </LayersControl.Overlay>
        <LayersControl.Overlay checked name="Stations">
          <LayerGroup>

            {props.routeMap.map((data) => {
              return (
                  <Marker 
                    key={data.id}
                    id={data.id}
                    position={L.latLng(data.station_lat, data.station_lng)} 
                    icon={customIconStation}
                  >
                    <Tooltip permanent>
                      <span>{data.stationname}</span>
                    </Tooltip>
                  </Marker>
              );
            })}
          </LayerGroup>
        </LayersControl.Overlay>
        <LayersControl.Overlay checked name="Car">
          <LayerGroup>
            {props.carInfo.map((data) => {
              if (data.route_id == routeAppContext.id) {
                return (
                  <Marker 
                    key={data.vehicle_id}
                    id={data.vehicle_id}
                    position={L.latLng(data.latitude, data.longitude)} 
                    icon={createVehicleIcon(data.heading  * (-1))}
                    // icon={createVehicleIcon( Math.floor(data.heading * 180 / Math.PI) * (-1) )}
                    draggable={true}
                    ref={markerRef}
                    eventHandlers={eventHandlers}
                    >
                      <Tooltip permanent>
                        <span>{data.vehicle_id}</span>
                        <span> Lat: {data.latitude}</span>
                        <span> Lng: {data.longitude}</span>
                        <span> Speed: {data.speed}</span>
                        <span> Heading: { data.heading } degree</span>
                      </Tooltip>
                  </Marker>
                );
              }
              
            })}
          </LayerGroup>
        </LayersControl.Overlay>
      </LayersControl>
    </>
  )
}

export default LayersRaxione